import React from "react";
import BackgroundImage from 'gatsby-background-image'
import { graphql, useStaticQuery } from 'gatsby';
import withStyles from "@material-ui/core/styles/withStyles";

function Connect({...props}) {
  const {
    className,
    imageUrl,
    children,
    style
  } = props;
  const data = useStaticQuery(
    graphql`
      query {
        desktop: file(relativePath: { eq: "connect.jpg" }) {
          childImageSharp {
            fluid(quality: 60, maxWidth: 960) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `
  );

  // Set ImageData.
  const imageData = data.desktop.childImageSharp.fluid;

  return (
    <BackgroundImage 
    Tag="div"
    role="img"
    aria-label="Three friends laughing on a city street."
    className={className}
    fluid={imageData}
    style={style}
    >
      {children}
    </BackgroundImage>
  )
};

const styles = {
  width: "100%",
  backgroundPosition: "center center",
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover"
};

export default withStyles(styles)(Connect);